/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Exit_PreviewInputs */

const en_ui_exit_preview = /** @type {(inputs: Ui_Exit_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exit preview`)
};

/** @type {(inputs: Ui_Exit_PreviewInputs) => LocalizedString} */
const ar_ui_exit_preview = en_ui_exit_preview;

/** @type {(inputs: Ui_Exit_PreviewInputs) => LocalizedString} */
const he_ui_exit_preview = en_ui_exit_preview;

/** @type {(inputs: Ui_Exit_PreviewInputs) => LocalizedString} */
const ur_ui_exit_preview = en_ui_exit_preview;

/** @type {(inputs: Ui_Exit_PreviewInputs) => LocalizedString} */
const es_ui_exit_preview = en_ui_exit_preview;

/** @type {(inputs: Ui_Exit_PreviewInputs) => LocalizedString} */
const fr_ui_exit_preview = en_ui_exit_preview;

/** @type {(inputs: Ui_Exit_PreviewInputs) => LocalizedString} */
const de_ui_exit_preview = en_ui_exit_preview;

/** @type {(inputs: Ui_Exit_PreviewInputs) => LocalizedString} */
const pt_ui_exit_preview = en_ui_exit_preview;

/** @type {(inputs: Ui_Exit_PreviewInputs) => LocalizedString} */
const hi_ui_exit_preview = en_ui_exit_preview;

/** @type {(inputs: Ui_Exit_PreviewInputs) => LocalizedString} */
const bn_ui_exit_preview = en_ui_exit_preview;

/**
* | output |
* | --- |
* | "Exit preview" |
*
* @param {Ui_Exit_PreviewInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const ui_exit_preview = /** @type {((inputs?: Ui_Exit_PreviewInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Exit_PreviewInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_ui_exit_preview(inputs)
	if (locale === "he") return he_ui_exit_preview(inputs)
	if (locale === "ur") return ur_ui_exit_preview(inputs)
	if (locale === "es") return es_ui_exit_preview(inputs)
	if (locale === "fr") return fr_ui_exit_preview(inputs)
	if (locale === "de") return de_ui_exit_preview(inputs)
	if (locale === "pt") return pt_ui_exit_preview(inputs)
	if (locale === "hi") return hi_ui_exit_preview(inputs)
	if (locale === "bn") return bn_ui_exit_preview(inputs)
	return /** @type {LocalizedString} */ ("Exit preview")
});